import React from "react";
import { Typography, Paper, Box, makeStyles } from "@material-ui/core";
import MuiLink from "@material-ui/core/Link";
import Moment from "react-moment";
import StHtml from "./StHtml";
import { Link } from "react-router-dom";
import useScreensize from "../../hooks/useScreensize";

const useStyles = makeStyles(theme => ({
  root: {
    overflow: "hidden",
    background: "rgba(255,255,255,0.9)"
  },
  img: {
    backgroundSize: "cover",
    backgroundPosition: "center center"
  },
  weiterlesen: {
    position: "absolute",
    right: theme.spacing(2),
    bottom: theme.spacing(1)
  }
}));

const replaceMapping = [
  { tag: "p", variant: "body2", component: "p", className: "" },
  { tag: "h1", variant: "h3", component: "h1", className: "" },
  { tag: "h2", variant: "h4", component: "h2", className: "" },
  { tag: "h3", variant: "h5", component: "h3", className: "" },
  { tag: "h4", variant: "h6", component: "h4", className: "" }
];

const StNews = ({ item }) => {
  const classes = useStyles();
  const { xs, sm, md, lg, xl, current } = useScreensize();

  if (!item) {
    return null;
  }

  const img =
    item.bilder && item.bilder.value.length ? item.bilder.value[0].url : null;

  console.log(item);

  return (
    <>
      <Paper className={classes.root}>
        <Box
          display="flex"
          height={{ xs: "auto", sm: 260 }}
          flexDirection={xs ? "column" : "row"}
        >
          <Box
            width={{ xs: "100%", sm: "33%" }}
            flexShrink={0}
            style={{ backgroundImage: "url(" + img + ")" }}
            className={classes.img}
            height={{ xs: 160, sm: "auto" }}
          ></Box>
          <Box
            flexGrow={1}
            px={2}
            pt={2}
            pb={{ xs: 6, sm: 2 }}
            position="relative"
          >
            <Typography variant="caption">
              <Moment format="DD.MM.YYYY">{item.datum.value}</Moment>
            </Typography>
            <MuiLink component={Link} to={`/news/${item.slug.value}`}>
              <Typography variant="h4" component="h2" gutterBottom>
                {item.titel.value}
              </Typography>
            </MuiLink>
            <StHtml replaceMapping={replaceMapping} teaser>
              {item.text.value}
            </StHtml>
            <MuiLink
              component={Link}
              to={`/news/${item.slug.value}`}
              className={classes.weiterlesen}
            >
              <Typography variant="overline">weiterlesen</Typography>
            </MuiLink>
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default StNews;
